import React from 'react';
import NumericInput from './NumericInput';

// TODO: add memo
const UsefullNumericInput = (props) => {
  const { value, minval, maxval, step, onChange, ...restProps } = props;

  return (
    <NumericInput
      {...restProps}
      value={value}
      step={step}
      min={minval}
      max={maxval}
      onInputChange={onChange}
    />
  );
};

export default UsefullNumericInput;
